import React from 'react';
import {Box, Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {formatDate} from '../../../utility/dateUtil';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ContentPasteOffRoundedIcon from '@mui/icons-material/ContentPasteOffRounded';
import {useGetFormsQuery, useUpdateFormStatusMutation} from '../../../api/services/formsService';
import withPagination from '../../../hoc/pagination/withPagination';
import AdmicityTable from '../../../shared-components/AdmicityTable';
import AdmicityStatus from '../../../shared-components/AdmicityStatus';
import {FORM_STATUSES, FORM_STATUSES_NAMES} from '../../../constants/formStatuses';
import useNotification from '../../../utility/hooks/useNotification';

const getFormStatusInfo = (status) =>
    ({
        label: FORM_STATUSES_NAMES[status] ?? 'unknown status',
        color: {
            [FORM_STATUSES.inactive]: 'blueGrey',
            [FORM_STATUSES.active]: 'green'
        }[status] ?? 'grey'
    });

const tableProps = {
    columns: [
        {
            field: 'name',
            headerName: 'Name',
            editable: false,
            sortable: false,
            minWidth: 300,
            flex: 1
        },
        {
            field: 'assignedGroups',
            headerName: 'Group',
            editable: false,
            sortable: false,
            minWidth: 500,
            flex: 2
        },
        {
            field: 'type',
            headerName: 'Type',
            editable: false,
            sortable: false,
            minWidth: 100,
            flex: 0.5
        },
        {
            field: 'status',
            headerName: 'Status',
            renderCell: (params) => params.row.status &&
                <AdmicityStatus {...getFormStatusInfo(params.row.status)}/>,
            editable: false,
            sortable: false,
            minWidth: 100,
            flex: 0.5
        },
        {
            field: 'createdAt',
            headerName: 'Created At',
            editable: false,
            valueGetter: (params) => formatDate(params.row.createdAt),
            sortable: false,
            minWidth: 150,
            flex: 0.5
        },
        {
            field: 'createdBy',
            headerName: 'Created By',
            editable: false,
            sortable: false,
            minWidth: 150,
            flex: 0.5,
        }
    ]
};

const Table = withPagination(AdmicityTable, useGetFormsQuery);

const Forms = () => {
    const [updateForm] = useUpdateFormStatusMutation();
    const navigate = useNavigate();
    const {showErrorNotification} = useNotification();

    const makeFormLive = async (selectedRow) => {
        const result = await updateForm({id: selectedRow.id});

        if (result.error) {
            showErrorNotification(result.error.data);
        }
    };

    const editForm = (selectedRow) => {
        navigate(`edit/${selectedRow.id}`);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minHeight: '100%'
            }}
        >
            <div>
                <Button
                    variant="contained"
                    onClick={() => navigate('new')}
                    sx={{mb: 2, mt: 2}}
                    startIcon={<AddCircleOutlineIcon/>}
                >
                    Create new Form
                </Button>
            </div>
            <Table
                columns={tableProps.columns}
                rowActions={[
                    {
                        label: 'Edit Form',
                        action: editForm
                    },
                    {
                        disabled: (selectedRow) => selectedRow && selectedRow.status === 'Active',
                        label: 'Make form live',
                        action: makeFormLive
                    }
                ]}
                noRowsOverlay={{
                    icon: <ContentPasteOffRoundedIcon/>,
                    text: 'No forms has been added'
                }}
            />
        </Box>);
};

export default Forms;
